
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLanguages } from '../../../services/Localization/LanguageService';

// Thunk to fetch languages
export const getLanguagesList = createAsyncThunk(
  'languages/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const res = await getLanguages();

      if (Array.isArray(res)) {
        return res.map((lang) => ({
          label: lang.name,
          value: lang.id,
        }));
      } else {
        return rejectWithValue('Invalid response format');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch languages');
    }
  }
);

const languageSlice = createSlice({
  name: 'languages',
  initialState: {
    languages: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    clearLanguages(state) {
      state.languages = [];
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLanguagesList.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getLanguagesList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.languages = action.payload;
      })
      .addCase(getLanguagesList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { clearLanguages } = languageSlice.actions;

export default languageSlice.reducer;
